// Link shape used by the official ChatGPT Work getting-started walkthrough.
// Opens a draft; the customer reviews it and presses Send in ChatGPT.
export function enlaceChatGPTWork(texto) {
  const params = new URLSearchParams({ prompt: texto, surface: "work" });
  return `https://chatgpt.com/?${params.toString()}`;
}
